import { Pencil } from "lucide-react";

interface DeliveryOrderBasicInformationProps {
  deliveryOrder: {
    bill_to: string;
    address: string;
    phone: string;
    delivery_order_no: string;
    delivery_date: string;
    po_number: string;
    customer_id: string;
    due_date: string;
    createdAt: string;
  };
  onEdit: () => void;
}

const formatDate = (value: string) =>
  new Intl.DateTimeFormat("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" }).format(
    new Date(value)
  );

export default function DeliveryOrderBasicInformation({
  deliveryOrder,
  onEdit,
}: DeliveryOrderBasicInformationProps) {
  return (
    <div className="rounded-2xl border border-gray-100 p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold">Basic Information</h3>
        <button
          onClick={onEdit}
          className="flex items-center gap-1 rounded-lg bg-blue-100 px-3 py-1.5 text-sm font-medium text-blue-600 hover:bg-blue-200"
        >
          <Pencil size={14} />
          Edit Delivery Order
        </button>
      </div>

      <div className="grid grid-cols-2 gap-x-10 gap-y-2 text-sm">
        <Row label="Bill To" value={deliveryOrder.bill_to} />
        <Row label="PO Number" value={deliveryOrder.po_number || "-"} />

        <Row label="Address" value={deliveryOrder.address || "-"} />
        <Row label="Customer ID" value={deliveryOrder.customer_id || "-"} />

        <Row label="Phone" value={deliveryOrder.phone || "-"} />
        <Row label="Due Date" value={formatDate(deliveryOrder.due_date)} />

        <Row label="No Delivery Order" value={deliveryOrder.delivery_order_no} />
        <Row label="" value="" />

        <Row label="Date" value={formatDate(deliveryOrder.delivery_date)} />
      </div>

      <p className="mt-4 flex items-center gap-1 text-xs text-gray-400">
        Create at {new Date(deliveryOrder.createdAt).toLocaleDateString("id-ID")}{" "}
        {new Date(deliveryOrder.createdAt).toLocaleTimeString("id-ID", {
          hour: "2-digit",
          minute: "2-digit",
        })}{" "}
        WIB
      </p>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  if (!label) return <div />;
  return (
    <div className="flex">
      <span className="w-36 shrink-0 text-gray-500">{label}</span>
      <span className="mr-2">:</span>
      <span className="font-medium text-gray-800">{value}</span>
    </div>
  );
}
